/* ==========================================================================
   NATURALE MASCOTA - DAR shared helpers (Kalles 4.3.8)
   - NM.formatMoney(cents): usa shop.money_format (window.NMConfig)
   - NM.getCart(): GET /cart.js (solo lectura, nunca agrega al carrito)
   - NM.tierState(totalCents): siguiente nivel de descuento
   - Evento 'nm:cart' en document con detail = cart (lo emite el cart drawer)
   - Reveal on scroll para .nm-reveal
   ========================================================================== */
(function () {
  if (window.NM) return;
  var cfg = window.NMConfig || {};

  function fmtNumber(cents, decimals, thousands, decimal) {
    var n = (Number(cents) || 0) / 100;
    var fixed = n.toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }

  function formatMoney(cents) {
    var format = cfg.moneyFormat || '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmtNumber(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNumber(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNumber(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNumber(cents, 2, "'", '.');
        default: return fmtNumber(cents, 2, ',', '.');
      }
    });
  }

  function getCart() {
    return fetch((cfg.cartUrl || '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // Linea de regalo: la que agrega el tema (variante configurada) o, si quedara, la de Corner Cart
  function isGift(it) {
    if (!it) return false;
    if (it.properties && (it.properties._nm_regalo || it.properties._corner_promo_code)) return true;
    return !!(cfg.gift && it.variant_id === cfg.gift.variantId && it.final_line_price === 0);
  }
  // Base de los niveles = subtotal despues de descuentos por producto (5x4, regalo) y antes del descuento
  // del pedido. Es el mismo subtotal que usa Shopify para el minimo de compra de sus descuentos.
  function tierBase(cart) {
    return (cart.items || []).reduce(function (s, it) { return s + (isGift(it) ? 0 : (it.final_line_price || 0)); }, 0);
  }
  // Regalo automatico: agrega 1 cuando la base llega al minimo y lo quita si baja.
  // Devuelve una promesa con true si cambio el carrito.
  var giftBusy = false;
  function syncGift(cart) {
    var g = cfg.gift;
    if (!g || !g.variantId || giftBusy || !cart) return Promise.resolve(false);
    var lines = (cart.items || []).filter(function (it) { return it.variant_id === g.variantId; });
    var qty = lines.reduce(function (s, it) { return s + it.quantity; }, 0);
    var wants = tierBase(cart) >= g.min ? 1 : 0;
    if (qty === wants) return Promise.resolve(false);
    giftBusy = true;
    var root = (cfg.rootUrl || '/').replace(/\/$/, '');
    var req;
    if (wants && !qty) {
      req = fetch(root + '/cart/add.js?nm_gift=1', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: g.variantId, quantity: 1, properties: { _nm_regalo: '1' } }] }) });
    } else {
      var updates = {};
      lines.forEach(function (it, i) { updates[it.key] = wants && i === 0 ? 1 : 0; });
      req = fetch(root + '/cart/update.js?nm_gift=1', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
    }
    return req.then(function (r) { giftBusy = false; return r.ok; }).catch(function () { giftBusy = false; return false; });
  }

  function tierState(total) {
    var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return a.amount - b.amount; });
    var reached = null, next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (total >= tiers[i].amount) reached = tiers[i];
      else if (!next) next = tiers[i];
    }
    var max = tiers.length ? tiers[tiers.length - 1].amount : 0;
    return {
      tiers: tiers,
      reached: reached,
      next: next,
      missing: next ? next.amount - total : 0,
      percent: max ? Math.min(100, Math.round((total / max) * 100)) : 0,
      freeShip: cfg.freeShipMin ? total >= cfg.freeShipMin : false
    };
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s == null ? '' : String(s)));
    return d.innerHTML;
  }

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.nm-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Carrusel scroll-snap: [data-nm-carousel] > [data-nm-track], [data-nm-prev], [data-nm-next], [data-nm-bar] */
  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-nm-carousel]').forEach(function (root) {
      if (root.dataset.nmCarInit === '1') return;
      var track = root.querySelector('[data-nm-track]');
      if (!track) return;
      root.dataset.nmCarInit = '1';
      var prev = root.querySelector('[data-nm-prev]');
      var next = root.querySelector('[data-nm-next]');
      var bar = root.querySelector('[data-nm-bar]');
      function stepSize() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var foot = root.querySelector('.nm-carousel__foot');
        if (foot) foot.style.visibility = max > 4 ? 'visible' : 'hidden';
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (bar) {
          var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
          var w = Math.max(0.12, Math.min(1, ratio));
          var pos = max > 0 ? track.scrollLeft / max : 0;
          bar.style.width = (w * 100) + '%';
          bar.style.transform = 'translateX(' + (pos * (1 - w) / w * 100) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize() * Math.max(1, Math.floor(track.clientWidth / stepSize())), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepSize() * Math.max(1, Math.floor(track.clientWidth / stepSize())), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
      root._nmUpdate = update;
    });
  }

  window.NM = {
    config: cfg,
    formatMoney: formatMoney,
    getCart: getCart,
    tierState: tierState,
    tierBase: tierBase,
    isGift: isGift,
    syncGift: syncGift,
    escapeHtml: escapeHtml,
    initReveal: initReveal,
    initCarousels: initCarousels
  };

  /* PDP con bloques Naturale: las recomendaciones nativas usan el mismo estilo de card */
  function tagRecommendations() {
    if (!document.querySelector('.nm-pdp-block')) return;
    document.querySelectorAll('[id*="product-recommendations"]').forEach(function (el) { el.classList.add('nm-cards'); });
  }

  function boot(scope) { initReveal(scope); initCarousels(scope); tagRecommendations(); }
  function giftOnLoad() {
    if (!cfg.gift) return;
    getCart().then(syncGift).then(function (changed) {
      if (!changed) return;
      var onCart = /\/cart\/?$/.test(location.pathname);
      if (onCart) {
        // una sola recarga por minuto para no entrar en bucle
        var k = 'nm_gift_reload', now = Date.now(), last = 0;
        try { last = parseInt(sessionStorage.getItem(k) || '0', 10); sessionStorage.setItem(k, String(now)); } catch (e) {}
        if (now - last > 60000) location.reload();
      } else if (window.cmxCart) window.cmxCart.refresh();
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); giftOnLoad(); });
  else { boot(); giftOnLoad(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
